export default "__VITE_ASSET__8cb739f8__"